import { ComponentProps, ReactNode } from "react";

import { cn } from "@/utils/cn";

type BlockFormProps = {} & ComponentProps<"div">;
function BlockForm({ className, children, ...props }: BlockFormProps) {
  return (
    <div className={cn(["flex flex-col gap-4 rounded-2xl bg-white px-6 py-6 shadow md:px-8 md:py-6", className])} {...props}>
      {children}
    </div>
  );
}

type BlockFormTitleProps = {
  children?: ReactNode;
  titleProps?: ComponentProps<"h1">;
} & ComponentProps<"div">;
function BlockFormTitle({ className, children, titleProps, ...props }: BlockFormTitleProps) {
  return (
    <div className={cn(["mb-4 flex flex-col gap-1 text-center", className])} {...props}>
      <h1 className={cn(["text-3xl font-medium text-gray-600", titleProps?.className])} {...titleProps}>
        {children}
      </h1>
    </div>
  );
}

export const Block = {
  Form: BlockForm,
  FormTitle: BlockFormTitle
};
